<template>
  <div>
    <div class="policy notifCont" v-if="travelPolicy">
      <div v-if="travelPolicy.summary.rulesTriggeredCount > 0">
        <b-tooltip multilined :position="position" type="is-light">
          <b-icon
            v-if="isShort"
            :type="tagType"
            icon="alert"
            size="is-default"
            class=""
          ></b-icon>

          <b-tag v-else :type="tagType" class="">
            <b-icon
              :icon="
                travelPolicy.summary.mostStrictApprovalRequired == 'soft'
                  ? 'alert'
                  : 'alert-octagon'
              "
              size="is-small"
            ></b-icon>
            <span>Out of Policy </span>
          </b-tag>
          <template v-slot:content>
            <h5 class="is-size-7 has-text-weight-bold has-text-left mb-1">
              {{ summaryHeading }}
            </h5>
            <ul class="has-text-left">
              <li
                class="is-size-7"
                v-for="item in travelPolicy.rulesTriggered"
                :key="item.message"
              >
                {{ item.message }}
              </li>
            </ul>
          </template>
        </b-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OutOfPolicyTag",
  props: {
    travelPolicy: Object,
    position: {
      type: String,
      default: "is-bottom",
    },
    isShort: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // active: false,
    };
  },
  mounted() {},
  methods: {},
  computed: {
    summaryHeading() {
      let heading = "Summary";

      if (this.travelPolicy.summary.mostStrictApprovalRequired == "soft") {
        heading = "Triggers Manager Notification";
      } else if (
        this.travelPolicy.summary.mostStrictApprovalRequired == "hard"
      ) {
        heading = "Requires Manager Approval";
      } else if (
        this.travelPolicy.summary.mostStrictApprovalRequired == "none"
      ) {
        heading = "Trip Will Be Logged for Reporting";
      } else if (this.travelPolicy.summary.visibility == "unselectable") {
        heading = "Not Allowed to Book";
      } else if (this.travelPolicy.summary.visibility == "hide") {
        heading = "Result Hidden";
      }

      return heading;
    },
    tagType() {
      let tagType = "is-light";

      if (this.travelPolicy.summary.mostStrictApprovalRequired == "soft") {
        tagType = "is-warning";
      } else if (
        this.travelPolicy.summary.mostStrictApprovalRequired == "hard"
      ) {
        tagType = "is-danger";
      }

      return tagType;
    },
  },
};
</script>

<style scoped></style>
